export const ApprovalPaths = {
  APPROVALS: 'approvals',
  TASK_APPROVE_REQUEST: 'task/:taskId/:requestId/:requestTypeId/approve-form',
};
